export default __webpack_public_path__ + "static/card-young-pretty-woman-4-fee39054f3a6735d669de8f9c8ed097c.png";